import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { StoreProfileDetail } from '../../types';
import { buildHistoryEntries } from '../../lib/retailerViewUtils';

interface HistoryViewProps {
  profile: StoreProfileDetail;
}

const kindLabels = {
  visit: 'Visit',
  campaign: 'Campaign',
  change: 'Change',
  evidence: 'Evidence',
} as const;

export function HistoryView({ profile }: HistoryViewProps) {
  const entries = buildHistoryEntries(profile).slice(0, 30);

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Store history</CardTitle>
        <p className="text-sm text-gray-500">
          Visits, campaigns and meaningful changes — newest first.
        </p>
      </CardHeader>
      <CardContent>
        {entries.length === 0 ? (
          <p className="text-sm text-gray-500 py-8 text-center">No history recorded yet.</p>
        ) : (
          <ol className="relative border-l-2 border-gray-200 ml-3 space-y-4 pl-6">
            {entries.map((entry) => (
              <li key={entry.id} className="relative">
                <span className="absolute -left-[1.85rem] w-3.5 h-3.5 rounded-full bg-white border-2 border-blue-400" aria-hidden />
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs text-gray-500 tabular-nums">{entry.date}</span>
                  <Badge variant="outline" className="text-[10px]">
                    {kindLabels[entry.kind]}
                  </Badge>
                </div>
                <p className="font-medium text-sm mt-0.5">{entry.title}</p>
                <p className="text-sm text-gray-600">{entry.description}</p>
              </li>
            ))}
          </ol>
        )}
      </CardContent>
    </Card>
  );
}
